import { useParams, useSearchParams } from 'react-router-dom'
import { fromBinary } from '@bufbuild/protobuf'
import { useStripe } from '@stripe/react-stripe-js'
import { useQuery } from '@tanstack/react-query'

import { ClientStateSchema } from '@jotta/grpc-connect-openapi/clientstate'
import { StripeElementsContainer } from '@jotta/settings/StripeContainer'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { Redirect } from '@jotta/ui/Redirect'
import { base64UrlSafeToBytes } from '@jotta/utils/base64'

import { useCheckAndConfirmStripe } from '../../payment/PaymentInformation'

function CheckAndConfirmPaypal({
  orderNumber,
  successPath,
  failurePath,
}: {
  orderNumber: string
  successPath: string
  failurePath: string
}) {
  const stripe = useStripe()
  const checkAndConfirm = useCheckAndConfirmStripe(successPath)

  const { isPending } = useQuery({
    throwOnError: false,
    enabled: Boolean(stripe),
    queryKey: ['checkAndConfirmPayPal'],
    queryFn: () => stripe && checkAndConfirm(stripe, orderNumber),
  })

  if (isPending) {
    return <LoadingOverlay id="PayPalPaymentRoute" open />
  }

  return <Redirect to={failurePath} />
}

export function PayPalPaymentRoute() {
  const { orderNumber } = useParams()
  const [searchParams] = useSearchParams()
  const stateBytesBase64 = searchParams.get('state')

  if (!orderNumber || !stateBytesBase64) {
    return <Redirect to="/" />
  }

  const clientState = fromBinary(
    ClientStateSchema,
    base64UrlSafeToBytes(stateBytesBase64),
  )

  return (
    <StripeElementsContainer>
      <CheckAndConfirmPaypal
        orderNumber={orderNumber}
        successPath={clientState.successPath}
        failurePath={clientState.failurePath}
      />
    </StripeElementsContainer>
  )
}
